export default __webpack_public_path__ + "static/media/icon_save.2740ceee.svg";